import { connect } from 'react-redux';
import {
  getCornerPosts,
  getInputDataToSend,
  getNecessaryProductsQuantity,
  getPanels,
  getPosts,
} from '../../../store/form/selectors';
import {
  calculateProductsQuantity,
  fetchFilters,
  fetchProductsBySection,
  setAccessoryList,
  setAddedProducts,
  setCornerAccessoryList,
  setCornerPostAccessoryList,
  setCornerPostsList,
  setInputDataToSend,
  setNecessaryProductsQuantity,
  setPostsList,
} from '../../../store/form/actions';
import { setValidation } from '../../../store/validation/actions';
import OrderForm from './OrderForm';

const mapStateToProps = (state) => ({
  inputData: getInputDataToSend(state),
  panels: getPanels(state),
  posts: getPosts(state),
  cornerPosts: getCornerPosts(state),
  necessaryProductsQuantity: getNecessaryProductsQuantity(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetchFilters: (filters) => dispatch(fetchFilters(filters)),
  setInputDataToSend: (key, data) => dispatch(setInputDataToSend(key, data)),
  fetchProductsBySection: (
    section,
    panelGroup,
    postGroup,
    accessoryGroup,
    color,
    type,
    height,
  ) => {
    dispatch(fetchProductsBySection(
      section,
      panelGroup,
      postGroup,
      accessoryGroup,
      color,
      type,
      height,
    ));
  },
  calculateProductsQuantity: (distance,
    panel,
    post,
    cornerPost,
    cornersQuantity,
    openingsQuantity,
    accessories,
    doublePost) => {
    dispatch(calculateProductsQuantity(
      distance,
      panel,
      post,
      cornerPost,
      cornersQuantity,
      openingsQuantity,
      accessories,
      doublePost,
    ));
  },
  setValidation: (
    validationField,
    validationContent,
  ) => dispatch(setValidation(
    validationField,
    validationContent,
  )),

  setAddedProducts: (uniqueItem) => {
    dispatch(setAddedProducts(uniqueItem));
  },

  setPostsList: (data) => {
    dispatch(setPostsList(data));
  },

  setAccessoryList: (data) => {
    dispatch(setAccessoryList(data));
  },

  setCornerPostsList: (data) => {
    dispatch(setCornerPostsList(data));
  },

  setCornerAccessoryList: (data) => {
    dispatch(setCornerAccessoryList(data));
  },

  setCornerPostAccessoryList: (data) => {
    dispatch(setCornerPostAccessoryList(data));
  },

  setNecessaryProductsQuantity: (data) => {
    dispatch(setNecessaryProductsQuantity(data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderForm);
